/**
 * CRA inlines REACT_APP_API_URL at build time.
 * Production (Hetzner): same-origin `https://reinventedsolutions.xyz` so the browser calls `/api/...`.
 * Local: typically `http://localhost:5717` from `.env.development` / `.env.local`
 * (see `scripts/local_dev_ports.env`).
 */
const HETZNER_PRODUCTION_ORIGIN = 'https://reinventedsolutions.xyz';

function sanitizeApiBaseUrl(url: string): string {
  const s = url.trim().replace(/\/$/, '');
  if (!s) {
    return s;
  }
  // Stale build-time hosts must not keep pointing the SPA at retired platforms.
  if (/\.onrender\.com$/i.test(s) || /onrender\.com\//i.test(s)) {
    return HETZNER_PRODUCTION_ORIGIN;
  }
  return s;
}

export function resolveReactAppApiBaseUrl(): string {
  if (typeof window !== 'undefined') {
    const host = (window.location.hostname || '').toLowerCase();
    if (
      host === 'reinventedsolutions.xyz' ||
      host === 'www.reinventedsolutions.xyz' ||
      host === 'app.reinventedsolutions.xyz'
    ) {
      return HETZNER_PRODUCTION_ORIGIN;
    }
  }

  let fromEnv = (process.env.REACT_APP_API_URL || '').trim().replace(/\/$/, '');
  if (fromEnv && /revolut\.com/i.test(fromEnv)) {
    fromEnv = '';
  }
  if (fromEnv) {
    return sanitizeApiBaseUrl(fromEnv);
  }
  // Dedicated local API port (scripts/local_dev_ports.env)
  return 'http://localhost:5717';
}
